import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper";

// Services
import {
    GetContentById,
    CreateContent,
    UpdateContent,
} from "./_services/Services.js"
import InputText from "components/Input/InputText.jsx";
import LinkOut from "./_components/LinkOut"
import Page from "./_components/Page"
import Error401 from "components/Error401"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const SitemapLv3Template = ({
    pageView = "create",
    pageName = "",
    componentKey = "",
    menuRoute="",
    menuLevel=1,
}) => {
    const _pageName = pageName ? pageName : `Page Route Settings`
    const _routePermission = `sitemap`
    // POPUP
    const { mAlert } = useContext(ModalContext);

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? 'TH'
    const [searchParams, setSearchParams] = useSearchParams();
    // const componentKey = qParams?.componentKey
    const navigate = useNavigate();

    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)
    const [contentDetail, setContentDetail] = useState()
    const [pageDetail, setPageDetail] = useState()
    const [prefillComplete, setPrefillComplete] = useState()
    const [pageType, setPageType] = useState(null)

    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        pageType: Yup.string().required("Please Select Page Type"),
        contentPageName: Yup.string().required("Please Enter Page Name"),

        contentLinkout: Yup.string().when('pageType', (pageType = '') => {
            return pageType == "link-out"
                ?   Yup.string().required("Please Enter Link Out")
                :   Yup.string().notRequired();
        }),

        slug: Yup.string().when('pageType', (pageType = '') => {
            return pageType == "page"
                ?   Yup.string().required("Please Enter Slug")
                :   Yup.string().notRequired();
        }),

        // contentDetail: Yup.string().when('pageType', (pageType = '') => {
        //     return pageType == "page"
        //         ?   Yup.string().required("Please Enter Detail")
        //         :   Yup.string().notRequired();
        // }),

        contentSeoTitle: Yup.string().when('pageType', (pageType = '') => {
            return pageType == "page"
                ?   Yup.string().max(255)
                :   Yup.string().notRequired();
        }),

        contentSeoKeyword: Yup.string().when('pageType', (pageType = '') => {
            return pageType == "page"
                ?   Yup.string().max(1024)
                :   Yup.string().notRequired();
        }),

        contentSeoDescription: Yup.string().when('pageType', (pageType = '') => {
            return pageType == "page"
                ?   Yup.string().max(1024)
                :   Yup.string().notRequired();
        }),
        
        bannerDesktop: Yup.object().when('pageType', (pageType = '') => {
            return pageType == "page"
                ?   Yup.object().test(
                        "is-not-empty-object",
                        "Please Upload Banner Desktop",
                        (value) => value && Object.keys(value).length > 0
                    ).required()
                :   Yup.object().notRequired();
        }),

        // thumbnail: Yup.object().when('pageType', (pageType = '') => {
        //     return pageType == "page"
        //         ?   Yup.object().test(
        //                 "is-not-empty-object",
        //                 "Please Upload thumbnail",
        //                 (value) => value && Object.keys(value).length > 0
        //             ).required()
        //         :   Yup.object().notRequired();
        // }),

        bannerMobile: Yup.object().when('pageType', (pageType = '') => {
            return pageType == "page"
                ?   Yup.object().test(
                        "is-not-empty-object",
                        "Please Upload Banner Mobile",
                        (value) => value && Object.keys(value).length > 0
                    ).required()
                :   Yup.object().notRequired();
        }),
        
        contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
        contentStatus: Yup.string().max(100).required("Please Enter Display"),
    })


    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

    const initialValues = {
        contentId: "",

        // ID
        pageType: "",
        slug: "",

        // Content
        contentPageName: "",
        contentLinkout: "",

        bannerDesktop: {},
        bannerMobile: {},
        // thumbnail: {},

        contentSeoTitle: "",
        contentSeoKeyword: "",
        contentSeoDescription: "",
        contentUpdateDate: moment().format("YYYY-MM-DD"),
        contentStatus: "active",
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log("🚀 ~ ExecutivesPageCreate ~ values:", values)
            const pageSettingRoute = {
                cate_id: menuLevel == 2 ? qParams.fromMenuId : null,
                contentPageName: values.contentPageName,
                slug: values.slug.replace(/-+$/, ''),
                pageType: values.pageType,
                parentId: menuLevel == 3 ? qParams.fromMenuId : null,
                contentLinkout: values.contentLinkout ? values.contentLinkout : null,
                attachmentData: {
                    bannerDesktop: values.bannerDesktop,
                    bannerMobile: values.bannerMobile,
                    // thumbnail: values.thumbnail,
                },
                contentAttachmentData: {

                },
                contentSeoTitle: values.contentSeoTitle,
                contentSeoKeyword: values.contentSeoKeyword,
                contentSeoDescription: values.contentSeoDescription,
                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,
            };

            console.log("🚀 ~ onSave ~ pageSettingRoute:", pageSettingRoute);

            setWaitSendData(true)
            if (pageView === "update") {
                API.fetchUpdateContentPageSetting(pageSettingRoute)
            }
            else {
                API.fetchCreateContentPageSetting(pageSettingRoute)
            }
        },
    })

    const preFilInputPage = (resData = {}) => {
        console.log("🚀 ~ preFilInputPage ~ resData:", resData)
        // resetForm(validation.values, initialValues)
        validation.setFieldValue("contentId", resData?.contentId ?? "")

        validation.setFieldValue("contentPageName", resData?.contentPageName ?? "")
        validation.setFieldValue("slug", resData?.slug ?? "")
        validation.setFieldValue("pageType", resData?.pageType ?? "")
        // validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
        validation.setFieldValue("bannerDesktop", resData?.contentBannerDesktop ?? "")
        validation.setFieldValue("bannerMobile", resData?.contentBannerMobile ?? "")
        // validation.setFieldValue("thumbnail", resData?.contentThumbnail ?? "")
        validation.setFieldValue("contentLinkout", resData?.contentLinkout ?? "")
        validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
        validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
        validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")

        validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
        validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")
    }

    const API = {
        fetchGetContentPageSetting: async componentKey => {
            try {
                const response = await GetContentById(menuLevel, 1, qParams?.id, {
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInputPage(resData.data)
                    setPageType(resData.data.pageType)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },
        fetchCreateContentPageSetting: async (payload) => {
            try {
                const response = await CreateContent(menuLevel, qParams?.fromMenuId, { data: payload, lang: qLang })
                const resData = response.data
                console.log({resData})
                if (resData.status == 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Create Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/business-feature-story/${qLang}`)
                            // navigate(`/${menuRoute}/page-setting/${qLang}`)
                            navigate(`/sitemap/level/${menuLevel}/fromMenuId/${qParams?.fromMenuId}/fromLevel/${Number(menuLevel) - 1}/${qLang}/edit/${resData.data.mainId}`)
                            window.location.reload()
                        },
                    })
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
        fetchUpdateContentPageSetting: async (payload) => {
            try {
                const response = await UpdateContent(menuLevel, qParams?.fromMenuId, qParams?.id, { data: payload, lang: qLang })
                const resData = response.data
                if (resData.status == 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/business-feature-story/${qLang}`)
                            // navigate(`/${menuRoute}/page-setting/${qLang}`)
                            window.location.reload()
                        },
                    })
                }
            }
            catch (err) {
                console.log('err ', err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        }
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            setContentLoading(true)
            API.fetchGetContentPageSetting(componentKey)
        }
    }, [qLang])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: '10px',
        border: '1px solid black',
        margin: '5px',
        borderRadius: '8px',
        background: '#f9f9f9',
        transition: 'transform 0.2s ease, background-color 0.3s ease',
    };

    const mapValues = (list = []) => list.map(item => {
        const newObj = {
            attachmentId: item.attachmentId,
            sequence: item.sequence
        }
        return newObj
    })

    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} ${_pageName}`}
                        breadcrumbItems={[
                            { title: _pageName, link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {
                        contentLoading
                            ? <Spinners setLoading={setContentLoading} />
                            :
                            <Row>
                                <Col className="col-12">
                                    <FormikProvider value={validation}>
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <Row>
                                                <Col className="col-8">
                                                    <Card>
                                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                            <i className='bx bx-cube-alt'></i> {_pageName}
                                                        </h5>
                                                        <CardBody>
                                                            <Row>
                                                                <Col className="col-12 mb-3">
                                                                    <Label for="exampleSelect">
                                                                        Page Type
                                                                    </Label>
                                                                    <Input
                                                                        id="pageType"
                                                                        className="form-control"
                                                                        type="select"
                                                                        placeholder=""
                                                                        name="pageType"
                                                                        onChange={e => {
                                                                            setPageType(e.target.value)
                                                                            validation.setFieldValue(
                                                                                "pageType",
                                                                                e.target.value
                                                                            )
                                                                        }}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.pageType}
                                                                        invalid={
                                                                            validation.touched.pageType &&
                                                                            validation.errors.pageType
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        disabled={['update', 'view'].includes(pageView)}
                                                                    >
                                                                        <option value=""></option>
                                                                        <option value="link-out" selected>Link Out</option>
                                                                        {pageType == 'page' && (
                                                                            <option value="page">Page</option>
                                                                        )}
                                                                    </Input>
                                                                    {validation.touched.pageType &&
                                                                    validation.errors.pageType && (
                                                                        <FormFeedback type="invalid">
                                                                            {validation.errors.pageType}
                                                                        </FormFeedback>
                                                                    )}
                                                                    <hr/>
                                                                </Col>
                                                                {
                                                                    pageType == 'link-out' && (
                                                                        <LinkOut validation={validation} pageView={pageView} />
                                                                    )
                                                                }
                                                                {
                                                                    pageType == 'page' && (
                                                                        <Page validation={validation} pageView={pageView} />
                                                                    )
                                                                }
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col className="col-4">
                                                    <Card outline color="primary" className="border sticky-element">
                                                        <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                            <i className='bx bx-check'></i> Tools Box
                                                        </h5>
                                                        <CardBody>
                                                            <Row>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Switch Language
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputLang widthfull pageView={pageView} forceRoute={false} />
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Written at
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputGroup>
                                                                            <Flatpickr
                                                                                className="form-control d-block"
                                                                                options={{
                                                                                    dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                                }}
                                                                                value={validation.values.contentUpdateDate ? moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                                                                disabled={true}
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                    disabled
                                                                                >
                                                                                    <i className="fa fa-calendar" aria-hidden="true" />
                                                                                </button>
                                                                            </div>
                                                                        </InputGroup>
                                                                        {
                                                                            (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Display
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                                                            onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                                                            getOptionValue={(option) => option.id}
                                                                            getOptionLabel={(option) => option.name}
                                                                            options={STATUS_OPTION}
                                                                            className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}`}
                                                                            isDisabled={pageView === "view"}
                                                                        />
                                                                        {
                                                                            (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                        <CardFooter>
                                                            <Row>
                                                                <Col className="text-start">
                                                                    <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/sitemap/level/${menuLevel}/fromMenuId/${qParams.fromMenuId}/fromLevel/${Number(menuLevel) - 1}/${qLang}`)}>Back</Button>
                                                                </Col>
                                                                <Col className="text-end">
                                                                    {pageView !== 'view' && (
                                                                        <Button type="submit" className="btn btn-success">
                                                                            Save  {waitSendData ? <Spinner size="sm" color="light" /> : null}
                                                                        </Button>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </CardFooter>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </FormikProvider>
                                </Col>
                            </Row>
                    }
                </Container>
            </div>
        </React.Fragment>
    )
}

// SitemapLv3Template.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(SitemapLv3Template)
